import React from 'react';

const Header = (a) => {
    return ( 
        <header className="bg-alerts">
            <h1>Drink finder</h1>
        </header>
     );
}
 
export default Header;